import {
  Amphora,
  Apple,
  Banana,
  Bean,
  Beef,
  Beer,
  Bird,
  Cake,
  CakeSlice,
  Candy,
  Carrot,
  Cherry,
  ChefHat,
  Citrus,
  Coffee,
  Cookie,
  CookingPot,
  Croissant,
  CupSoda,
  Dessert,
  Donut,
  Drumstick,
  Egg,
  EggFried,
  Fish,
  Flame,
  GlassWater,
  Grape,
  Ham,
  HandPlatter,
  IceCreamCone,
  LayoutGrid,
  Leaf,
  Lollipop,
  Martini,
  Milk,
  Nut,
  Pizza,
  Popcorn,
  Salad,
  Sandwich,
  Shell,
  Soup,
  Sprout,
  Utensils,
  UtensilsCrossed,
  Vegan,
  Wheat,
  Wine,
  Zap,
  type LucideIcon,
} from 'lucide-react';
import type { Category } from '@shared/schemas';

// Curated food/drink icon set for categories. The chosen icon's NAME is stored
// in the category's `emoji` field (so no DB migration — that column now holds an
// icon key instead of an emoji character).
export const ICON_OPTIONS: { name: string; Icon: LucideIcon }[] = [
  { name: 'Utensils', Icon: Utensils },
  { name: 'UtensilsCrossed', Icon: UtensilsCrossed },
  { name: 'Beef', Icon: Beef },
  { name: 'Drumstick', Icon: Drumstick },
  { name: 'Ham', Icon: Ham },
  { name: 'Fish', Icon: Fish },
  { name: 'Egg', Icon: Egg },
  { name: 'EggFried', Icon: EggFried },
  { name: 'Salad', Icon: Salad },
  { name: 'Carrot', Icon: Carrot },
  { name: 'Leaf', Icon: Leaf },
  { name: 'Sprout', Icon: Sprout },
  { name: 'Vegan', Icon: Vegan },
  { name: 'Bean', Icon: Bean },
  { name: 'Nut', Icon: Nut },
  { name: 'Soup', Icon: Soup },
  { name: 'CookingPot', Icon: CookingPot },
  { name: 'HandPlatter', Icon: HandPlatter },
  { name: 'Pizza', Icon: Pizza },
  { name: 'Sandwich', Icon: Sandwich },
  { name: 'Shell', Icon: Shell },
  { name: 'Amphora', Icon: Amphora },
  { name: 'Wheat', Icon: Wheat },
  { name: 'Croissant', Icon: Croissant },
  { name: 'CakeSlice', Icon: CakeSlice },
  { name: 'Cake', Icon: Cake },
  { name: 'Dessert', Icon: Dessert },
  { name: 'Cookie', Icon: Cookie },
  { name: 'Donut', Icon: Donut },
  { name: 'Candy', Icon: Candy },
  { name: 'Lollipop', Icon: Lollipop },
  { name: 'Popcorn', Icon: Popcorn },
  { name: 'IceCreamCone', Icon: IceCreamCone },
  { name: 'Apple', Icon: Apple },
  { name: 'Banana', Icon: Banana },
  { name: 'Cherry', Icon: Cherry },
  { name: 'Grape', Icon: Grape },
  { name: 'Citrus', Icon: Citrus },
  { name: 'Coffee', Icon: Coffee },
  { name: 'Milk', Icon: Milk },
  { name: 'GlassWater', Icon: GlassWater },
  { name: 'CupSoda', Icon: CupSoda },
  { name: 'Wine', Icon: Wine },
  { name: 'Martini', Icon: Martini },
  { name: 'Beer', Icon: Beer },
  { name: 'Flame', Icon: Flame },
  { name: 'Zap', Icon: Zap },
  { name: 'Bird', Icon: Bird },
  { name: 'ChefHat', Icon: ChefHat },
];

const REGISTRY: Record<string, LucideIcon> = Object.fromEntries(
  ICON_OPTIONS.map((o) => [o.name, o.Icon]),
);

// Sensible defaults for the original production categories, used when a category
// has no explicitly-picked icon yet (its `emoji` still holds an emoji char).
const BY_SLUG: Record<string, LucideIcon> = {
  rychlovky: Zap,
  bezmase: Carrot,
  peceni: Croissant,
  sladke: CakeSlice,
  polevky: Soup,
  zdrave: Salad,
  maso: Beef,
  snidane: Egg,
  asie: CookingPot,
};

export const ALL_ICON: LucideIcon = LayoutGrid;
export const DEFAULT_ICON_NAME = 'Utensils';

export function iconByName(name: string): LucideIcon {
  return REGISTRY[name] ?? Utensils;
}

export function iconForCategory(category: Pick<Category, 'emoji' | 'slug'>): LucideIcon {
  return REGISTRY[category.emoji] ?? BY_SLUG[category.slug] ?? Utensils;
}
